import { workflowTypes } from './workflowTypes';

/**
 * @typedef {Object} WorkflowConfig
 * @property {string} id - The ID of the workflow
 * @property {string} path - The path to the workflow
 * @property {string} buttonText - The text to display on the button
 * @property {string} icon - The icon to display on the button
 * @property {string} variant - The variant of the button
 * @property {string} workflowType - The ID of the workflow type
 * @property {(location: import('react-router-dom').Location) => boolean} shouldDisplay - Determines if the workflow should be displayed based on the current page
 */

/**
 * @type {WorkflowConfig[]}
 */
export const workflowConfigs = [
  {
    id: 'wallet',
    path: '/wallet-profile',
    buttonText: 'Full Wallet Profile',
    icon: 'wallet',
    variant: 'falcon-default',
    workflowType: workflowTypes.INVESTIGATE_FULL_WALLET_PROFILE,
    shouldDisplay: (location) => {
      const { pathname } = location;
      return (
        pathname.startsWith('/wallet-profile') && pathname !== '/wallet-profile'
      );
    },
  },
  {
    id: 'wallet',
    path: '/wallet-profile',
    buttonText: 'Investigate Wallet for KYC Data',
    icon: 'wallet',
    variant: 'falcon-default',
    workflowType: workflowTypes.INVESTIGATE_WALLET_FOR_KYC_DATA,
    shouldDisplay: (location) => {
      const { pathname } = location;
      return (
        pathname.startsWith('/wallet-profile') && pathname !== '/wallet-profile'
      );
    },
  },

  {
    id: 'transaction',
    path: '/transaction-decoder',
    buttonText: 'Decode and Explain Transaction',
    icon: 'wallet',
    variant: 'falcon-default',
    workflowType: workflowTypes.INVESTIGATE_FULL_DECODER,
    shouldDisplay: (location) => {
      const { pathname } = location;
      return (
        pathname.startsWith('/transaction-decoder') &&
        pathname !== '/transaction-decoder'
      );
    },
  },
  {
    id: 'contractAnalysis',
    path: '/contract-analysis',
    buttonText: 'Analyze Contract Structure',
    icon: 'puzzle-piece',
    variant: 'falcon-default',
    workflowType: workflowTypes.INVESTIGATE_FULL_CONTRACT_ANALYSIS,
    shouldDisplay: (location) => {
      const { pathname } = location;
      return (
        pathname.startsWith('/contract-analysis') &&
        pathname !== '/contract-analysis'
      );
    },
  },
  {
    id: 'tracer',
    path: 'tracer',
    buttonText: 'Find Next Nodes',
    icon: 'shuffle',
    variant: 'falcon-default',
    workflowType: workflowTypes.FIND_NEXT_TRACER_NODE,
    shouldDisplay: (location) => {
      const { pathname } = location;
      return pathname.startsWith('/tracer');
    },
  },
  {
    id: 'currentPage',
    path: '',
    buttonText: 'Analyze current page',
    icon: 'file',
    variant: 'falcon-primary',
    workflowType: workflowTypes.ANALYZE_CURRENT_PAGE,
    shouldDisplay: () => {
      return true;
    },
  },
];
